<template>
    <transition name="component-fade" mode="out-in" v-on:before-enter="onBeforeEnter" v-on:enter="onEnter">
        <router-view v-bind:lead="lead" v-on:complete="onStepComplete" v-on:invalidInput="logInvalidInputEvent"></router-view>
    </transition>
</template>

<script>

import { steps, stepValues } from "./steps.js";

export default {
    data: function() {
        return {
            queriedLeadInfo: false
        }
    },
    props: {
        lead: Object,
        eventBus: Object
    },
    mounted: function() {
        this.eventBus.$on("goToPreviousStep", this.goToPreviousStep);
        this.eventBus.$on("goToStep", this.goToStep);
    },
    methods: {
        onBeforeEnter: function() {
            this.$emit("preStepTransition")
        },
        onEnter: function() {
            this.$emit("postStepTransition")
        },
        onStepComplete: function(name, value) {
            this.utils.log("onStepComplete: " + this.currentStep);
			this.utils.log(value);
			this.utils.log(this.lead);

            this.$emit("stepComplete");
            this.$gtag.event(value ? value.toString() : null, {"event_category": this.currentStep, "event_label": this.lead.id});
			this.goToNextStep(value);
        },
        currentStepIndex: function() {
            return steps.indexOf(this.currentStep);
        },
        goToPreviousStep: function() {
            this.$gtag.event("back", {"event_category": this.currentStep, "event_label": this.lead.id});
            this.utils.log("goToPreviousStep from " + this.currentStep);

            if (this.currentStep != steps[0]) {

                // do some clean up for certain steps
                switch (this.currentStep) {
                    case stepValues.VehicleMake.name:
                        this.lead.vehicles[this.lead.vehicles.length - 1].year = null;
                        break;
                    case stepValues.VehicleModel.name:
                        this.lead.vehicles[this.lead.vehicles.length - 1].make = null;
                        break;
                    case stepValues.VehicleTrim.name:
                        this.lead.vehicles[this.lead.vehicles.length - 1].model = null;
                        break;
                    case stepValues.VehicleVin.name:
                        this.lead.vehicles[this.lead.vehicles.length - 1].trim = null;
                        break;
                }

                this.$router.go(-1);
            }
        },
        nextStep: function() {
            var currentStepIndex = this.currentStepIndex();

            if (currentStepIndex >= 0 && currentStepIndex + 1 < steps.length) {
                return steps[currentStepIndex + 1];
            }

            return this.$route.path.replace("/", "");
        },
        goToNextStep: function(val) {
            var nextStep = "";

            switch (this.currentStep) {
                case stepValues.InsuranceType:
                    if (this.lead.insuranceType == "Auto") {
                        nextStep = stepValues.Name;
                    }
                    break;
                case stepValues.IsInsured:
                    if (this.lead.isInsured) {
                        nextStep = stepValues.CurrentInsurer;
                    }
                    else {
                        nextStep = stepValues.RequestedCoverageType;
                    }
                    break;
                case stepValues.Email:
                    if (this.appConfig.queryLeadInfo) {
                        var pendingVehicles = this.lead.pendingVehicles;

                        if (pendingVehicles.length == 0 && !this.queriedLeadInfo) {
                            this.utils.log("going to queryLeadInfo");
                            this.queryLeadInfo();
                            nextStep = null;
                        }
                        else {
                            if (pendingVehicles.length > 0) {
                                this.utils.log("going to vehicleConfirmation");
                                nextStep = stepValues.VehicleConfirmation;
                            }
                            else {
                                this.utils.log("going to vehicleYear");
                                nextStep = stepValues.VehicleYear;
                                this.lead.vehicles = [{ "year": "", "make": "", "model": "", "trim": ""}];
                            }
                        }
                    }
                    else {
                        nextStep = stepValues.VehicleYear;
                        this.lead.vehicles = [{ "year": "", "make": "", "model": "", "trim": ""}];
                    }
                    break;
                case stepValues.VehicleConfirmation:
                    this.lead.vehicles = [];
                    if (val) {
                        // copy any selected ones
                        this.lead.pendingVehicles.forEach((pendingVehicle) => {
                            if (pendingVehicle.selected) {
                                this.tryToSetVehicleTrim(pendingVehicle);
                                this.lead.vehicles.push(pendingVehicle);
                            }
                        });

                        this.utils.log("using pending vehicles");
                    }

                    if (this.lead.vehicles.length > 0) {
                        this.$gtag.event("using pending vehicles", {"event_category": "App", "event_label": this.lead.id});
                        nextStep = stepValues.IsInsured;
                    } else {
                        this.$gtag.event("not using pending vehicles", {"event_category": "App", "event_label": this.lead.id});
                        this.lead.vehicles = [{ "year": "", "make": "", "model": "", "trim": ""}];
                        nextStep = stepValues.VehicleYear;
                    }
                    break;
                case stepValues.AddAnotherVehicle:
                    if (val) {
                        this.lead.vehicles.push({ "year": "", "make": "", "model": "", "trim": ""});
                        nextStep = stepValues.VehicleYear;
                    }
                    else {
                        nextStep = stepValues.IsInsured;

                        // clean up any empty vehicles
                        if (this.lead.vehicles) {
                            var vehicle = this.lead.vehicles[this.lead.vehicles.length - 1];

                            if (!vehicle.year || !vehicle.make || !vehicle.model || !vehicle.trim) {
                                this.lead.vehicles.pop();
                            }
                        }
                    }
                    break;
                case stepValues.PhoneNumber:
                    this.$emit("complete");
                    nextStep = null;
                    break;
                default:
                    nextStep = this.nextStep();
                    break;
            }

            if (nextStep) {
                this.$emit("loading", false);
                this.utils.log("goToNextStep from " + this.currentStep + " to " + nextStep);
                this.$router.push(nextStep);
            }
        },
        goToStep: function(step) {
            this.utils.log("goToStep");
            this.utils.log(step);
            var nextStep = step;

            this.$router.push(nextStep);
        },
        logInvalidInputEvent: function(step, value) {
            this.utils.log("logInvalidInputEvent: " + step + ", " + value);
            this.$gtag.event("invalid: '" + value.toString() + "'", {"event_category": step, "event_label": this.lead.id});
        },
        queryLeadInfo: function() {
            this.$emit("loading", true);
            var query = this.getQuery();
            this.utils.log("quering lead info");
            this.utils.log(query);

            var vm = this;

            this.axios.post("/Api/Widget/QueryLeadInfo", query)
                .then(function (response) {
                    vm.utils.log("queried lead");
                    vm.utils.log(response);
                    vm.handleQueryResponse(response);
                })
                .catch(function (error) {
                    var errorMessage = "error querying lead";

                    if (error.response) {
                        errorMessage += " - status " + error.response.status;
                    }
                    else if (error.request) {
                        errorMessage += " - no response (" + error.request.status + ")";
                    }
                    else {
                        errorMessage += " - error " + error.message;
                    }

                    vm.utils.log(errorMessage);
                    vm.utils.log(error);

                    try {
                        vm.$gtag.event("error querying lead", {"event_category": "App", "event_label": this.lead.id});
                    } catch (e) {
                        vm.utils.log(e);
                    }

                    vm.handleQueryResponse(error);
                });
        },
        getQuery: function() {
            return {
                Id: this.lead.id,
				ApiKey: this.appConfig.apiKey,
				DateOfBirth: this.getDateOfBirth(),
				StreetAddress: this.lead.streetAddress,
				City: this.lead.city,
                State: this.lead.state,
				ZipCode: this.lead.zipCode,
				FirstName: this.lead.firstName,
				LastName: this.lead.lastName,
				Email: this.lead.email
			}
        },
        getDateOfBirth: function() {
            return this.lead.dateOfBirthYear + "-" + this.lead.dateOfBirthMonth + "-" + this.lead.dateOfBirthDay;
        },
        handleQueryResponse: function(response) {

            if (response.data) {
                var vehicles = response.data.Vehicles;
                if (vehicles) {
                    vehicles.forEach((vehicle) => {
                        var leadVehicle = {
                            "year": vehicle.Year,
                            "make": vehicle.Make,
                            "model": vehicle.Model,
                            "trim": vehicle.Trim,
                            "vin": vehicle.Vin,
                            "primaryUse": vehicle.PrimaryUseType,
                            "annualMileage": vehicle.AnnualMileage,
                            "daysDrivenPerWeek": vehicle.DaysDrivenPerWeek,
                            "selected": true
                        };
                        this.lead.pendingVehicles.push(leadVehicle);
                    });

                    this.utils.log("added pendingVehicles")
                    this.utils.log(this.lead.pendingVehicles);
                }
            }

            this.queriedLeadInfo = true;
            this.goToNextStep();
        },
        tryToSetVehicleTrim: function(pendingVehicle) {
            this.utils.log("tryToSetVehicleTrim");

            // look up trims
            if (!pendingVehicle.trim) {
                if (typeof window.AvengeDigitalWidgetYearMakeModelTrims !== "undefined") {

                    try {
                        var year = pendingVehicle.year;
                        var make = this.utils.toTitleCase(pendingVehicle.make);
                        var model = this.utils.toTitleCase(pendingVehicle.model);
                        var trims = window.AvengeDigitalWidgetYearMakeModelTrims;

                        this.utils.log("looking up " + year + " " + make + " " + model);

                        if (trims[year] && trims[year][make] && trims[year][make][model] && trims[year][make][model].length > 0) {
                            pendingVehicle.trim = trims[year][make][model][0];
                            this.utils.log("set trim to " + pendingVehicle.trim);
                        }
                        else {
                            this.utils.log("unable to set vehicle trim");
                            this.$gtag.event("unable to set vehicle trim", {"event_category": "App", "event_label": this.lead.id, "value": year + " " + make + " " + model});
                        }
                    }
                    catch (e) {
                        this.utils.log("error trying to set vehicle trim");
                        this.utils.log(e);
                        this.$gtag.event("unable to set vehicle trim", {"event_category": "App", "event_label": this.lead.id, "value": e.message});
                    }
                }
            }
        }
    },
    computed: {
        currentStep: function () {
            return this.$route.path.replace("/", "");
        }
    }
}

</script>

<style scoped>
    .component-fade-enter-active, .component-fade-leave-active {
      transition: opacity .2s ease;
    }

    .component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
</style>
